import { router } from '@inertiajs/react'
import { Badge } from '@/components/ui/Badge'
import { Button } from '@/components/ui/Button'
import { TASK_STATE_BADGE, type TaskWidget } from '../TopDown/components/PlanTaskWidget'

// Header widget on a channel editor (Products & Pricings, By Month): the
// connected task's state and PICs, what is still missing, and the Submit verb
// as a link to the page's submit route, same as the Top Down PlanTaskWidget.
// The server only sends `task_widget` to the task's PICs
// (Plan::CycleTaskProps), so rendering it at all is already the visibility check.
export default function ChannelTaskWidget({ task, missing, submitHref }: { task: TaskWidget; missing: string[]; submitHref: string }) {
  const badge = TASK_STATE_BADGE[task.state] ?? { label: task.state, variant: 'secondary' as const }
  // In review = the PIC's turn is over; no verb until the reviewer acts.
  const showSubmit = task.state === 'pending' || task.state === 'changes_requested'
  const verb = task.has_reviewers ? 'Submit' : 'Mark completed'
  const ready = missing.length === 0

  return (
    <div
      className="flex min-w-0 flex-col gap-0.5 rounded-lg border px-3 py-1.5"
      style={{ background: 'var(--background)', borderColor: 'var(--border)' }}
    >
      <div className="flex items-center gap-2">
        <Badge variant={badge.variant} className="px-1.5 py-0 text-[10px] whitespace-nowrap">
          {badge.label}
        </Badge>
        <span className="max-w-[280px] truncate text-xs font-medium text-foreground" title={task.details}>
          {task.details}
        </span>
      </div>
      <div className="flex items-center gap-2 text-[11px] text-muted-foreground">
        <span className="max-w-[160px] truncate" title={task.pic_names.join(', ')}>
          {task.pic_names.join(', ')}
        </span>
        {showSubmit && (
          <>
            <span>·</span>
            <span className="whitespace-nowrap">{ready ? 'Ready to submit' : `Missing: ${missing.join(', ')}`}</span>
            <Button
              size="sm"
              className="ml-auto h-5 px-2 text-[11px]"
              disabled={!ready}
              onClick={() => router.visit(submitHref)}
            >
              {verb}
            </Button>
          </>
        )}
      </div>
    </div>
  )
}
